/* @ngInject */
const axletreeRequest = (
  $q,
  utils,
  axletreeResource,
  axletreeFormat,
  errorHandler,
  valueHandler,
  labels
) => {
  const self = {}

  self.getBySearch = async (_data) => {
    return $q((resolve, reject) => {
      const functionName = '$$axletree.getBySearch'
      const data = axletreeFormat.server(_data)

      axletreeResource.post({ action: 'search', }, { search: data }, (res) => {
        if (res && res.success && valueHandler.isArray(res.data)) {
          const response = {
            axletrees: res.data,
            message: labels.axletree.log.search.success(res.data.length),
            color: res.data.length === 0 ? 'orange' : 'green',
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, data)
          reject(labels.axletree.log.search.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.save = (_axletree) => {
    return $q((resolve, reject) => {
      const functionName = '$$axletree.save'
      const axletree = axletreeFormat.server(_axletree)

      axletreeResource.save({}, axletree, (res) => {
        if (res && res.success && res.message && res.data.id) {
          const response = {
            id: res.data.id,
            message: res.message,
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          if (res.code === 2) {
            reject(labels.axletree.log.save.alreadyExists)
          } else {
            errorHandler.message(res, functionName, _axletree)
            reject(labels.axletree.log.save.failure)
          }
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.saveAll = async (_axletrees, _wagonId) => {
    const loopPromises = []

    utils.forEach(_axletrees, async (axletree) => {
      const deferred = $q.defer()
      loopPromises.push(deferred.promise)
      axletree.wagonId = _wagonId

      try {
        const response = await self.save(axletree)
        deferred.resolve(response)
      } catch (error) {
        deferred.reject(error)
      }
    })
    return $q.all(loopPromises)
  }

  self.delete = async (_id) => {
    return $q((resolve, reject) => {
      const functionName = '$$axletree.save'

      axletreeResource.delete({ action: _id, }, (res) => {
        if (res && res.success && res.message) {
          resolve(res.message)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, _id)
          reject(labels.axletree.log.delete.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.getByWagon = async (_wagonId) => {
    return $q((resolve, reject) => {
      const functionName = '$$axletree.getByWagon'

      axletreeResource.post({ action: 'get-by-wagon', }, { wagonId: _wagonId, }, (res) => {
        if (res && res.success && res.message) {
          resolve(res.data)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, _wagonId)
          reject(labels.axletree.log.search.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  return self
}
export default axletreeRequest



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/axletree/services/request.service.js